module.exports = "/_next/static/images/Frame-07d1480bbcf04ad93b1b247aaf1053d6.webp";